<template lang="pug">
.receipt-table
  v-container(fluid)
    v-layout
      v-flex
        v-data-table(
          :headers="headers"
          :items="items"
          :search="search"
          :pagination.sync="pagination"
          item-key="value"
          hide-actions)
          template(v-slot:no-data)
            v-alert(
              :value="true"
              color="error"
              icon="warning") 目前尚無資料
          template(v-slot:items="props")
            td
              v-btn(
                :disabled="!props.item.settled"
                flat
                small
                icon
                color="warning"
                @click="print(props.item)")
                v-icon print
            td.text-xs-center(
              v-for="action in activeActions"
              :key="action.value")
              v-btn(
                flat
                small
                icon
                @click="$emit(action.value, props.item)")
                v-icon {{ action.value }}
            td {{ props.item.serialNumber }}
            td {{ props.item.creationTime | timestampFilter }}
            td {{ props.item.payer.displayName }}
            td.text-xs-left
              v-chip(
                v-for="item in props.item.items"
                disabled)
                v-avatar(
                  color="green"
                  text-color="white") {{ item.year }}
                .detail {{ item | receiptItemFilter }}
            td {{ props.item.total }}
            td {{ props.item.settled | boolean }}
            td {{ props.item.disabled | boolean }}
            td {{ props.item.payee.displayName }}
            td {{ props.item.settler ? props.item.settler.displayName : '-' }}
            td {{ props.item.id }}
    v-dialog(v-model="printting")
      v-card(
        color="primary"
        dark)
        v-card-text {{ printState }}
        v-progress-linear(
          indeterminate
          color="white"
          class="mb-0")
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { db } from "@/firebase";
import generateReceiptDoc from "@/utils/generateReceiptDoc";

const dataHeaders = [
  { text: "列印", value: "print" },
  { text: "流水號", value: "serialNumber" },
  { text: "開立時間", value: "creationTime" },
  { text: "會員姓名", value: "displayName" },
  { text: "繳款項目", value: "items" },
  { text: "總額", value: "total" },
  { text: "結算", value: "settled" },
  { text: "作廢", value: "disabled" },
  { text: "經手人", value: "payee" },
  { text: "結算人", value: "settler" },
  { text: "單據id", value: "id" }
];

export default {
  name: "UserReceiptTable",
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      search: "",
      items: [],
      pagination: {
        rowsPerPage: -1,
        sortBy: "creationTime",
        descending: true
      },
      printting: false,
      printState: ""
    };
  },
  computed: {
    ...mapGetters("auth", ["role"]),
    activeActions() {
      // 暫時取消
      /*
      return ['super', 'admin', 'manager'].some(p => p === this.role)
        ? [{ text: '修改', value: 'edit' }]
        : []
      */
      return [];
    },
    headers() {
      return this.activeActions.concat(dataHeaders);
    }
  },
  mounted() {
    db.collection("receipts")
      .where("payer.uid", "==", this.user.uid)
      .get()
      .then(snap => {
        const items = [];

        snap.forEach(doc => {
          const data = doc.data();
          data.id = doc.id;
          items.push(data);
        });

        this.items = items;
      });
  },
  methods: {
    ...mapActions("print", ["loadJsPDF", "loadFont", "createDoc"]),
    async print(receipt) {
      this.printting = true;

      this.printState = "載入列印工具";
      await this.loadJsPDF();
      this.printState = "載入字體";
      await this.loadFont();
      this.state = "取得用戶資料";
      const payerData = (await db
        .collection("users")
        .doc(receipt.payer.uid)
        .get()).data();

      this.printState = "產生PDF...";
      this.createDoc(generateReceiptDoc([{ receipt, payer: payerData }]));

      this.printting = false;
    }
  }
};
</script>
